module.exports = __webpack_public_path__ + "static/media/alterarSenha.e9a977b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/alterarSenha.png
// module id = 394
// module chunks = 0